import { Link, type LinkProps } from 'react-router-dom';
import { permissionForPath } from '@klothiq/domain';
import { useAuth } from '@/contexts/AuthContext';
/** Navigation actions use the same permission catalog as route guards. */
export default function AccessLink(props: LinkProps) {
  const { can } = useAuth();
  const path = typeof props.to === 'string' ? props.to.split(/[?#]/)[0] : props.to.pathname;
  const permission = path?.startsWith('/') ? permissionForPath(path) : undefined;
  if (permission && !can(permission)) return null;
  return <Link {...props} />;
}
